import Vue from 'vue'
import api from './api';
import moment from 'moment'
import App from './App.vue'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false;

Object.defineProperties(Vue.prototype, {
    $api: {
        get() {
            return api
        }
    }
});

const moneyFormatter = new Intl.NumberFormat('ru', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});

Vue.filter('msisdn', function (val) {
    let cleaned = ('' + val).replace(/\D/g, ''),
        match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }

    return val;
});

Vue.filter('price', function (val) {
    return isNaN(val) ? val : moneyFormatter.format(val);
});

Vue.filter('formatDate', function(value, format) {
    if (!format) {
        format = 'DD.MM.YYYY'
    }
    if (value) {
        return moment(String(value)).format(format)
    }
});

new Vue({
    vuetify,
    render: h => h(App)
}).$mount('#app');
